import React from 'react';
import { PaperclipIcon } from '../../../components/icons/Icons';

export default function InvoiceDetailModal({ invoice, onClose }) {
    if (!invoice) return null;

    const DetailItem = ({ label, value }) => (
        <div className="grid grid-cols-3 gap-4 py-2">
            <dt className="text-sm font-medium text-gray-500">{label}</dt>
            <dd className="text-sm text-gray-900 col-span-2">{value}</dd>
        </div>
    );

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-2xl max-h-full overflow-y-auto">
                <div className="flex justify-between items-center pb-4 border-b">
                     <h2 className="text-xl font-bold text-[#213368]">Invoice Details</h2>
                     <button onClick={onClose} className="text-gray-400 hover:text-gray-600 font-bold text-2xl">&times;</button>
                </div>
               
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 mt-4">
                    <dl className="divide-y divide-gray-200">
                        <DetailItem label="Invoice ID" value={invoice.invoiceNumber} />
                        <DetailItem label="Vendor" value={invoice.vendorName} />
                        <DetailItem label="Department" value={invoice.department || 'N/A'} />
                        <DetailItem label="Amount" value={`${invoice.currency} ${invoice.amount}`} />
                        <DetailItem label="Due Date" value={invoice.dueDate.toDate().toLocaleDateString()} />
                    </dl>
                     <dl className="divide-y divide-gray-200">
                        <DetailItem label="Submitted By" value={invoice.submittedBy} />
                        <DetailItem label="Submission Date" value={invoice.createdAt.toDate().toLocaleDateString()} />
                        <DetailItem label="Approved By" value={invoice.approvedBy || 'N/A'} />
                        <DetailItem label="Approval Date" value={invoice.approvalDate ? invoice.approvalDate.toDate().toLocaleDateString() : 'N/A'} />
                    </dl>
                </div>

                <div className="mt-4 pt-4 border-t">
                    <DetailItem label="Submitter Comments" value={invoice.comments || 'None'} />
                    {invoice.approvalComments && <DetailItem label="Approver Comments" value={invoice.approvalComments} />}
                </div>

                <div className="mt-4 pt-4 border-t">
                    <div className="grid grid-cols-3 gap-4">
                        <dt className="text-sm font-medium text-gray-500">Invoice Attachment</dt>
                        <dd className="text-sm text-gray-900 col-span-2">
                             {invoice.invoiceFile?.url ? (
                                <a 
                                    href={invoice.invoiceFile.url} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="flex items-center font-medium text-blue-600 hover:text-blue-800"
                                >
                                    <PaperclipIcon />
                                    <span className="ml-2">{invoice.invoiceFile.name}</span>
                                </a>
                            ) : ( 'No attachment found.' )}
                        </dd>
                    </div>
                </div>

                {/* --- NEW: Audit Trail Section --- */}
                {invoice.auditTrail && invoice.auditTrail.length > 0 && (
                    <div className="mt-6 pt-4 border-t">
                        <h3 className="text-lg font-medium text-gray-800 mb-2">Payment Audit Trail</h3>
                        <ul className="space-y-2">
                            {invoice.auditTrail.map((entry, index) => (
                                <li key={index} className="flex items-center text-sm p-2 bg-gray-50 rounded-md">
                                    <span className="font-semibold text-gray-700 w-1/3">{entry.action}</span>
                                    <span className="text-gray-600 w-1/3">{entry.user}</span>
                                    <span className="text-gray-500 w-1/3 text-right">
                                        {entry.timestamp ? entry.timestamp.toDate().toLocaleString() : 'Pending...'}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}


                <div className="flex justify-end pt-6 mt-4 border-t">
                    <button 
                        onClick={onClose} 
                        className="px-6 py-2 bg-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-300 transition-colors duration-200"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

